import React from "react";
import { DataGrid, gridColumnGroupsLookupSelector } from "@mui/x-data-grid";
import { InputGroup, InputGroupText, Input, Button, Spinner } from "reactstrap";
import { convertPayments } from "../Utils/payments";
import axios from "axios";
import { baseUrl } from "..";
import Tooltip from "@mui/material/Tooltip";
import { Box, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import { toast } from "react-toastify";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { generateHTMLToPDF } from "../Utils/htmlToPdf";
import withRouter from "../Components/withRouter";
import { generateweekylyTransactionBill } from "../Utils/htmlToPdfBill";
import { downloadCSV } from "../Utils/downloadCSV";
import { downloadSingleReservations } from "../Utils/downloadCSV";
class Payments extends React.Component {
  constructor() {
    super();
    this.state = {
      utrNumbers: new Map(),
      isLaptop: window.matchMedia("(min-width: 1024px)").matches, // Check initial screen size
      isMobile: window.matchMedia("(max-width: 768px)").matches,
      pageSize: 10,
      open: false,
      selectedBooking: null,
      selectedHostelId:
        this.props?.userContext?.selectedHostelId ||
        localStorage.getItem("selectedHostel") ||
        "",
      currentPage: 0,
      searchInput: "",
      allTableData: [],
      weeklyReservationData: [],
      invoiceAddress: "",
      loading: false,
      deductionsMap:new Map(),
      column: [
        {
          field: "startDate",
          headerName: "Booking Week (Start)",
          width: "110",
        },
        {
          field: "endDate",
          headerName: "Booking Week (End)",
          width: "110",
        },

        {
          field: "collectionPeriod",
          headerName: "THC Commission",
          width: "130",
        },
        {
          field: "tax",
          headerName: "Tax",
          width: "50",
        },
        {
          field: "thcDiscountCoupons",
          headerName: "THC (Discount + Coupons + Wallet)",
          width: "200",
        },
        {
          field: "totalValueReceived",
          headerName: "Hostel Revenue",
          width: "220",
        },
        {
          field: "collectionAtPos",
          headerName: "Collection at Purchase",
          width: "140",
        },
        {
          field: "collectedAtCheckin",
          headerName: "Collected by Hostel@Checkin",
          width: "280",
        },
        {
          field: "thcOwesHostel",
          headerName: "THC Owes Hostel (Pre-Deduction)",
          width: "280",
        },
        {
          field: "isTransferred",
          headerName: "Is it Transferred?",
          editable: true,
          width: "140",
        },

        {
          field: "utrNumber",
          headerName: "UTR number",
          editable: false,
          width: 140,
          renderCell: (params) => (
            <div
              style={{
                cursor: "pointer",
                width: "130px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              onClick={() => {
                if (params.value) {
                  navigator.clipboard.writeText(params.value);
                  toast.info("UTR Copied", {
                    autoClose: 500,
                    style: {
                      background: "#e0e0e0",
                      color: "#333",
                      fontSize: "14px",
                      borderRadius: "8px",
                      padding: "8px 16px",
                    },
                    icon: false,
                  });
                }
              }}
            >
              {params.value || ""}
            </div>
          ),
        },
        {
          field: "paidAmount",
          headerName: "Paid Amount",
          editable: true,
          width: "160",
        },
        {
          field: "deductionAmount",
          headerName: "Deductions",
          editable: true,
          width: "160",
        },

        {
          field: "deductionComment",
          headerName: "Deduction Comment",
          editable: true,
          width: "160",
        },
        {
          field: "downloadBill",
          headerName: "Download Invoice",
          width: "180",
          renderHeader: () => (
            <Tooltip title=" download the bill of the week" arrow>
              <span>Download Invoice</span>
            </Tooltip>
          ),
          renderCell: (params) => (
            <div
              onClick={() => this.downloadWeeklyBill(params)}
              style={{
                color: "black",
                border: "none",
                padding: "5px 10px",
                cursor: "pointer",
                display: "flex",
                gap: "5px",
                alignContent: "center",
                alignItems: "center",
              }}
            >
              <i class="bi bi-download"></i> Download
            </div>
          ),
        },
        {
          field: "downloadReservations",
          headerName: "Download reservations",
          width: "180",
          renderHeader: () => (
            <Tooltip title=" download the full details of the week" arrow>
              <span>Download Reservations</span>
            </Tooltip>
          ),
          renderCell: (params) => (
            <div
              onClick={() => this.downloadWeekInvoice(params)}
              style={{
                // backgroundColor: '#1976d2',
                color: "black",
                border: "none",
                padding: "5px 10px",
                cursor: "pointer",
                display: "flex",
                gap: "5px",
                alignContent: "center",
                alignItems: "center",
              }}
            >
              <i class="bi bi-download"></i> Download
            </div>
          ),
        },
        {
          field: "downloadReservationsCsv",
          headerName: "Download CSV",
          width: "180",
          renderHeader: () => (
            <Tooltip title=" download the full details of the week" arrow>
              <span>Download CSV</span>
            </Tooltip>
          ),
          renderCell: (params) => (
            <div
              onClick={() => this.downloadWeeklyCsv(params)}
              style={{
                color: "black",
                border: "none",
                padding: "5px 10px",
                cursor: "pointer",
                display: "flex",
                gap: "5px",
                alignContent: "center",
                alignItems: "center",
              }}
            >
              <i class="bi bi-download"></i> Download
            </div>
          ),
        },

        {
          field: "transferredTime",
          headerName: "transferredTime",
          editable: true,
          width: "160",
        },
      ],
    };
  }
  downloadWeekInvoice = (params) => {
    function getISOWeekDetails(date) {
      const tempDate = new Date(date);
      tempDate.setUTCDate(
        tempDate.getUTCDate() + 4 - (tempDate.getUTCDay() || 7),
      ); // Set to Thursday to ensure we're in the correct week
      const yearStart = new Date(Date.UTC(tempDate.getUTCFullYear(), 0, 1));
      const weekNumber = Math.ceil(((tempDate - yearStart) / 86400000 + 1) / 7);

      // Calculate week start (Monday) and week end (Sunday)
      const weekStart = new Date(tempDate);
      weekStart.setUTCDate(
        weekStart.getUTCDate() - (weekStart.getUTCDay() || 7) + 1,
      ); // Set to Monday
      const weekEnd = new Date(weekStart);
      weekEnd.setUTCDate(weekEnd.getUTCDate() + 6); // Set to Sunday

      return {
        week: weekNumber,
        year: tempDate.getUTCFullYear(),
        weekStart,
        weekEnd,
      };
    }
    let weekStart;
    let weekEnd;
    if (this.state.isMobile) {
      weekStart = this.state.selectedBooking.startDate;
      weekEnd = this.state.selectedBooking.endDate;
    } else {
      weekStart = params.row.startDate;
      weekEnd = params.row.endDate;
    }

    const { week, year } = getISOWeekDetails(weekStart);

    const weekNumber = `${year}-W${week}`;
    const weekData = this.state.weeklyReservationData.map((weeks) => {
      if (weeks.week === weekNumber) {
        if (this.state.isMobile) {
          generateHTMLToPDF(weeks.reservations, weekStart, weekEnd);
        } else {
          generateHTMLToPDF(weeks.reservations, weekStart, weekEnd);
        }
      }
    });
  };
  downloadWeeklyCsv = (params) => {
    function getISOWeekDetails(date) {
      const tempDate = new Date(date);
      tempDate.setUTCDate(
        tempDate.getUTCDate() + 4 - (tempDate.getUTCDay() || 7),
      ); // Set to Thursday to ensure we're in the correct week
      const yearStart = new Date(Date.UTC(tempDate.getUTCFullYear(), 0, 1));
      const weekNumber = Math.ceil(((tempDate - yearStart) / 86400000 + 1) / 7);

      // Calculate week start (Monday) and week end (Sunday)
      const weekStart = new Date(tempDate);
      weekStart.setUTCDate(
        weekStart.getUTCDate() - (weekStart.getUTCDay() || 7) + 1,
      ); // Set to Monday
      const weekEnd = new Date(weekStart);
      weekEnd.setUTCDate(weekEnd.getUTCDate() + 6); // Set to Sunday

      return {
        week: weekNumber,
        year: tempDate.getUTCFullYear(),
        weekStart,
        weekEnd,
      };
    }
    let weekStart;
    let weekEnd;
    if (this.state.isMobile) {
      weekStart = this.state.selectedBooking.startDate;
      weekEnd = this.state.selectedBooking.endDate;
    } else {
      weekStart = params.row.startDate;
      weekEnd = params.row.endDate;
    }

    const { week, year } = getISOWeekDetails(weekStart);

    const weekNumber = `${year}-W${week}`;
    const matchedWeek = this.state.weeklyReservationData.find(
      (week) => week.week === weekNumber,
    );

    if (matchedWeek) {
      downloadSingleReservations(matchedWeek.reservations, weekStart, weekEnd);
    }
  };

  
  downloadWeeklyBill = (params) => {
    function getISOWeekDetails(date) {
      const tempDate = new Date(date);
      tempDate.setUTCDate(
        tempDate.getUTCDate() + 4 - (tempDate.getUTCDay() || 7),
      ); // Set to Thursday to ensure we're in the correct week
      const yearStart = new Date(Date.UTC(tempDate.getUTCFullYear(), 0, 1));
      const weekNumber = Math.ceil(((tempDate - yearStart) / 86400000 + 1) / 7);

      // Calculate week start (Monday) and week end (Sunday)
      const weekStart = new Date(tempDate);
      weekStart.setUTCDate(
        weekStart.getUTCDate() - (weekStart.getUTCDay() || 7) + 1,
      ); // Set to Monday
      const weekEnd = new Date(weekStart);
      weekEnd.setUTCDate(weekEnd.getUTCDate() + 6); // Set to Sunday

      return {
        week: weekNumber,
        year: tempDate.getUTCFullYear(),
        weekStart,
        weekEnd,
      };
    }
    let weekStart;
    let weekEnd;
    if (this.state.isMobile) {
      weekStart = this.state.selectedBooking.startDate;
      weekEnd = this.state.selectedBooking.endDate;
    } else {
      weekStart = params.row.startDate;
      weekEnd = params.row.endDate;
    }

    const { week, year } = getISOWeekDetails(weekStart);

    const weekNumber = `${year}-W${week}`;
    const weekData = this.state.weeklyReservationData.map((weeks, index) => {
      if (weeks.week === weekNumber) {
        if (this.state.isMobile) {
          generateweekylyTransactionBill(
            weeks.reservations,
            weekStart,
            weekEnd,
            this.state.invoiceAddress,
            index,
          );
        } else {
          generateweekylyTransactionBill(
            weeks.reservations,
            weekStart,
            weekEnd,
            this.state.invoiceAddress,
            index,
          );
        }
      }
    });
  };

  async componentDidMount() {
    const { selectedHostelId } = this.props?.userContext?.selectedHostelId;
    this.setState({
      selectedHostelId: selectedHostelId,
    });
    await this.fetchUtrNumbers();
    this.fetchInvoiceAddress();
    this.fetchPayments();
    this.fetchDeductions();


    this.mediaQuery = window.matchMedia("(min-width: 1024px)");
    this.mediaQuery.addEventListener("change", this.handleResize);
    this.mediaQueryList = window.matchMedia("(max-width: 768px)");
    this.mediaQueryList.addEventListener("change", this.updateScreenSize);
  }

  async componentDidUpdate(prevProps) {
    const currentHostelId = this.props?.userContext?.selectedHostelId;
    const previousHostelId = prevProps?.userContext?.selectedHostelId;

    if (currentHostelId !== previousHostelId && currentHostelId) {
      this.setState(
        {
          selectedHostelId: currentHostelId,
          invoiceAddress: "",
          utrNumbers: new Map(),
        },
        async () => {
          await this.fetchUtrNumbers();
          this.fetchInvoiceAddress();
          this.fetchPayments();
          this.fetchDeductions();
        },
      );
    }
  }


  fetchDeductions = async()=>{
    try {

       const selectedHostelId =
        this.props?.userContext?.selectedHostelId ||
        this.state.selectedHostelId;
      if (!selectedHostelId) {
        console.log("No hostel selected, skipping fetch");
        return;
      }

       const headers = {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                  },
                };
          
                const res = await axios.get(
                  `${baseUrl}/deductions/${selectedHostelId}`,
                  headers
                );

          if (res.status === 200) {
  const data = res.data.deductions || [];
  const dMap = new Map();  

  data.forEach((d) => {
    const prev = dMap.get(d.week_start_date) || 0;
    dMap.set(d.week_start_date, prev + Number(d.cancelled_amount)); 
  });

  this.setState({ deductionsMap: dMap });
}
      
    } catch (error) {
      console.log("error in getting deductions ", error);
      
    }
  }

  fetchInvoiceAddress = async () => {
    try {
      const selectedHostelId =
        this.props?.userContext?.selectedHostelId ||
        this.state.selectedHostelId;
      if (!selectedHostelId) {
        console.log("No hostel selected, skipping fetch");
        return;
      }
      const headers = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };

      const res = await axios.get(
        `${baseUrl}/hostel/invoice-address/${selectedHostelId}`,
        headers,
      );
      if (res.status === 200) {
        this.setState({ invoiceAddress: res.data.invoice[0] });
      }
    } catch (error) {
      console.log("error in getting invoice address", error);
    }
  };

  fetchUtrNumbers = async () => {
    this.setState({ loading: true });
    const headers = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };
    try {
      const response = await axios.get(
        `${baseUrl}/payments/get-payments-utr/${this.state.selectedHostelId}`,
        headers,
      );
      if (response.status === 200) {
        const utrMap = new Map();
        response.data.transactions.forEach((utrData) => {
          utrMap.set(utrData.startDate, {
            utrNumber: utrData.utrNumber,
            transferredTime: utrData.transferredDateTime,
            deductionComment: utrData?.deduction_comment,
            paidAmount: utrData?.amount,
          });
        });
        this.setState({ utrNumbers: utrMap }, () => {
          console.log("UTR map updated", this.state.utrNumbers);
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  fetchPayments = () => {
    const selectedHostelId =
      this.props?.userContext?.selectedHostelId || this.state.selectedHostelId;

    // Don't fetch if no hostel is selected
    if (!selectedHostelId) {
      console.log("No hostel selected, skipping fetch");
      return;
    }

    const headers = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };
    axios
      .get(`${baseUrl}/reservations/${selectedHostelId}`, headers)
      .then((res) => {
        const reservations = res.data;
        reservations.sort(
          (a, b) => new Date(b.bookingDate) - new Date(a.bookingDate),
        );
        function getISOWeekDetails(date) {
          const tempDate = new Date(date);
          tempDate.setUTCDate(
            tempDate.getUTCDate() + 4 - (tempDate.getUTCDay() || 7),
          ); // Set to Thursday to ensure we're in the correct week
          const yearStart = new Date(Date.UTC(tempDate.getUTCFullYear(), 0, 1));
          const weekNumber = Math.ceil(
            ((tempDate - yearStart) / 86400000 + 1) / 7,
          );

          // Calculate week start (Monday) and week end (Sunday)
          const weekStart = new Date(tempDate);
          weekStart.setUTCDate(
            weekStart.getUTCDate() - (weekStart.getUTCDay() || 7) + 1,
          ); // Set to Monday
          const weekEnd = new Date(weekStart);
          weekEnd.setUTCDate(weekEnd.getUTCDate() + 6); // Set to Sunday

          return {
            week: weekNumber,
            year: tempDate.getUTCFullYear(),
            weekStart,
            weekEnd,
          };
        }

        // Group reservations by ISO week
        const weeklyData = reservations.reduce((acc, reservation) => {
          const cancelledStatuses = ["cancel", "cancelled"];
          if (cancelledStatuses.includes(reservation?.status?.toLowerCase())) {
            return acc;
          }

          const bookingDate = new Date(reservation.bookingDate);
          const { week, year, weekStart, weekEnd } =
            getISOWeekDetails(bookingDate);

          const weekKey = `${year}-W${week}`;
          const formattedDate = new Date(weekStart).toISOString().split("T")[0];
          const transferredTime =
            this.state.utrNumbers?.get(formattedDate)?.transferredTime ?? "";
          const utrNumber =
            this.state.utrNumbers?.get(formattedDate)?.utrNumber ?? "";
          const paidAmount =
            this.state.utrNumbers?.get(formattedDate)?.paidAmount ?? "";
          const deductionComment =
            this.state.utrNumbers?.get(formattedDate)?.deductionComment ?? "";
          const deductionAmount =
            this.state.deductionsMap?.get(formattedDate) ?? "";
          if (!acc[weekKey]) {
            acc[weekKey] = {
              week,
              year,
              weekStart,
              weekEnd,
              reservations: [],
            };
          }

          acc[weekKey].reservations.push({
            ...reservation,
            utrNumber: utrNumber,
            transferredTime: transferredTime,
            paidAmount: paidAmount,
            deductionComment: deductionComment,
            deductionAmount: deductionAmount,
          });
          return acc;
        }, {});

        // Convert the weekly data into an array of weeks
        const formattedWeeklyData = Object.entries(weeklyData).map(
          ([weekKey, data]) => ({
            week: `${data.year}-W${data.week}`,
            weekStart: data.weekStart,
            weekEnd: data.weekEnd,
            reservations: data.reservations,
          }),
        );

        this.setState({ weeklyReservationData: formattedWeeklyData }, () => {
          const aggregateWeeklyData = () => {
            let aggregatedWeeklyData = [];

            this.state.weeklyReservationData.forEach((weeklyData) => {
              const week = weeklyData.reservations;
              const totalBedsSum = week.reduce(
                (sum, r) => sum + r?.totalRooms,
                0,
              );
              const costOfBeds = Math.round(
                week.reduce((sum, r) => sum + r?.originalPrice, 0),
              );
              const totalTax = Math.round(
                week.reduce((sum, r) => sum + r?.totalTax, 0),
              );
              const totalHostelRevenue = Math.round(
                week.reduce((sum, r) => sum + r?.totalHostelRevenue, 0),
              );
              const thcComission = week.reduce(
                (sum, r) => sum + r.comissionAmt,
                0,
              );
const thcDiscount = Math.round(
  week.reduce((sum, r) =>
    sum + (r.thcCouponAmt || 0) + (r.thcCoinAmt || 0)
        + (r.thcDiscount || 0) + (r.thcAppDiscount || 0)
        - ((r.platformFee || 0) - (r.platformFeeCollected || 0)), 0)
);
            const PaymentCollectedFromCustomer = Math.round(
  week.reduce((sum, r) =>
    sum + (r.PaymentCollectedFromCustomer || 0) - (r.platformFeeCollected || 0), 0)
);
              const PaymentPendingfromCustomer = Math.round(
                week.reduce((sum, r) => sum + r?.PaymentPendingFromCustomer, 0),
              );

const THCOwesHostel = Math.round(
  week.reduce((sum, r) =>
    sum
    + (r.PaymentCollectedFromCustomer || 0)
    - (r.platformFee || 0)
    + (r.thcCouponAmt || 0)
    + (r.thcCoinAmt || 0)
    + (r.thcDiscount || 0)
    + (r.thcAppDiscount || 0)
    - (r.comissionAmt || 0)
  , 0)
);
              const StarDatetTimestamp = new Date(weeklyData.weekStart);
              const startDate = StarDatetTimestamp.toISOString().split("T")[0];
              const endDateTimestamp = new Date(weeklyData.weekEnd);
              const endDate = endDateTimestamp.toISOString().split("T")[0];
              const utrTransactionNumber =
                this.state.utrNumbers.get(startDate)?.utrNumber || "";
              const paidAmount =
                this.state.utrNumbers.get(startDate)?.paidAmount || "";
              const deductionComment =
                this.state.utrNumbers.get(startDate)?.deductionComment || "";
              const rawTime =
                this.state.utrNumbers.get(startDate)?.transferredTime ||
                "not available";
              const deductionAmount =
                this.state.deductionsMap.get(startDate) || "";
              // Clean the string to remove newlines and trim whitespace
              const transferredTime = rawTime.replace(/\s+/g, " ").trim();
              const aggregatedWeek = {
                startDate: startDate,
                endDate: endDate,
                totalBeds: totalBedsSum,
                costOfBeds,
                totalTax,
                totalHostelRevenue,
                thcComission,
                thcDiscount,
                PaymentCollectedFromCustomer,
                PaymentPendingfromCustomer,
                THCOwesHostel,
                utrNumber: utrTransactionNumber,
                transferredTime: transferredTime,
                paidAmount: paidAmount,
                deductionComment: deductionComment,
                deductionAmount: deductionAmount,
              };
              aggregatedWeeklyData.push(aggregatedWeek);
            });

            console.log(aggregatedWeeklyData);
            const formattedWeeklyData = convertPayments(aggregatedWeeklyData);
            this.setState({ allTableData: formattedWeeklyData });
          };

          aggregateWeeklyData();
        });
      })
      .catch((err) => {
        console.log(err.message);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };
  handleResize = (event) => {
    this.setState({ isLaptop: event.matches });
  };

  updateScreenSize = (event) => {
    this.setState({ isMobile: event.matches });
  };

  handleCardClick = (booking) => {
    this.setState({
      selectedBooking: booking,
      open: true,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
      selectedBooking: null,
    });
  };
handleCsvDownload = () => {
  const sampleData = this.state.allTableData;
  if (!sampleData) return;

  const formattedData = sampleData.map(
    ({ cost, status, limitPerUser, id, paidAmount, deductionComment,platformFeeCollected,checkoutDiscountOnRoom , deductionAmount, ...item }) => ({
      ...item,
      amountToBePaidByThc:item.thcOwesHostel || 0
    })
  );

  downloadCSV(formattedData, "payments.csv");
};

  render() {
    const onChange = (e) => {
      const { name, value } = e.target;
      if (name === "pageSize") {
        this.setState({ currentPage: 0 });
      }
      this.setState({ [name]: value });
    };
    return (
      <div className="m-5">
        {/* <Button className="bg-secondary-o text-dark-o border-0" color="dark">
                        Download
                    </Button> */}
        {this.state.isLaptop && !this.state.loading && (
          <>
            <div className="d-flex justify-content-between mb-3">
              <InputGroup className="border rounded w-25">
                <InputGroupText className="bg-transparent border-0">
                  <i class="bi bi-search"></i>
                </InputGroupText>
                <Input
                  className="border-0"
                  placeholder="Search..."
                  onChange={onChange}
                  value={this.state.searchInput}
                  name="searchInput"
                />
              </InputGroup>
              <button onClick={this.handleCsvDownload}>Download CSV</button>
              {/* <Button className="bg-secondary-o text-dark-o border-0" color="dark">
                                Download
                            </Button> */}
            </div>
            <DataGrid
              sx={{
                "& .MuiDataGrid-columnHeader": {
                  padding: "10px 8px",
                  alignItems: "center",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  whiteSpace: "normal",
                  lineHeight: "1.3",
                  textAlign: "center",
                  fontSize: "13px",
                },
              }}
              columnHeaderHeight={90}
              rows={this.state.allTableData}
              columns={this.state.column}
              pageSize={this.state.pageSize}
              rowsPerPageOptions={[1, 2, 4]}
              pagination
              autoHeight
              onPageChange={(params) =>
                this.setState({ currentPage: params.page })
              }
              onPageSizeChange={(params) =>
                this.setState({ pageSize: params.pageSize })
              }
              getRowId={(row) => row.id}
            />
          </>
        )}
        {this.state.isMobile && !this.state.loading && (
          <>
            <div className="d-flex flex-column align-items-center justify-content-center pb-2">
              <button onClick={this.handleCsvDownload}>Download CSV</button>
            </div>
            {[...this.state.allTableData]
              .sort((a, b) => {
                const durationA = new Date(a.endDate) - new Date(a.startDate);
                const durationB = new Date(b.endDate) - new Date(b.startDate);
                return durationB - durationA; // descending order
              })
              .map((eachCard) => {
                return (
                  <React.Fragment key={eachCard.id}>
                    {" "}
                    {/* Make sure each child has a key */}
                    <Dialog
                      fullScreen
                      open={
                        this.state.open &&
                        this.state.selectedBooking?.id === eachCard.id
                      }
                      onClose={this.handleClose}
                      fullWidth
                      maxWidth="sm"
                    >
                      {/* Centered image below title */}
                      {this.state.selectedBooking && (
                        <Typography
                          variant="h4"
                          sx={{
                            mt: 1,
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          {this.state.selectedBooking.customerName}
                        </Typography>
                      )}
                      <Paper
                        elevation={5}
                        sx={{
                          borderRadius: 6,
                          padding: 1,
                          mt: 7,
                          ml: 4,
                          mr: 4,
                          mb: 4,
                        }}
                      >
                        <Typography
                          sx={{ fontSize: "30px", textAlign: "center" }}
                        >
                          <strong>Payment Summary</strong>
                        </Typography>
                        <hr style={{ borderTop: "2px solid #000000" }}></hr>
                        <DialogContent>
                          {this.state.selectedBooking && (
                            <Box>
                              <Typography>
                                Customer Payment At CheckIn:{" "}
                                <strong>
                                  {
                                    this.state.selectedBooking
                                      .collectedAtCheckin
                                  }
                                </strong>
                              </Typography>
                              <Typography sx={{ mt: 2, fontSize: "15px" }}>
                                Amount Already Paid By Customer:{" "}
                                <strong>
                                  {this.state.selectedBooking.collectionAtPos}
                                </strong>
                              </Typography>
                              <Typography sx={{ mt: 2, fontSize: "15px" }}>
                                Week Start Date:{" "}
                                <strong>
                                  {this.state.selectedBooking.startDate}
                                </strong>
                              </Typography>
                              <Typography sx={{ mt: 2, fontSize: "15px" }}>
                                Week End Date:{" "}
                                <strong>
                                  {this.state.selectedBooking.endDate}
                                </strong>
                              </Typography>
                              <Typography sx={{ mt: 2, fontSize: "15px" }}>
                                Tax:{" "}
                                <strong>
                                  {this.state.selectedBooking.tax}
                                </strong>
                              </Typography>
                              <Typography sx={{ mt: 2, fontSize: "15px" }}>
                                Hostel Revenue:{" "}
                                <strong>
                                  {
                                    this.state.selectedBooking
                                      .totalValueReceived
                                  }
                                </strong>
                              </Typography>
                              <Typography sx={{ mt: 2, fontSize: "15px" }}>
                                Amount THC Owes To The Hostel:{" "}
                                <strong>
                                  {this.state.selectedBooking.thcOwesHostel}
                                </strong>
                              </Typography>
                              <Typography sx={{ mt: 2, fontSize: "15px" }}>
                                THC Funded Discount + Coupon:{" "}
                                <strong>
                                  {
                                    this.state.selectedBooking
                                      .thcDiscountCoupons
                                  }
                                </strong>
                              </Typography>
                              <Typography sx={{ mt: 2, fontSize: "15px" }}>
                                THC Fees:{" "}
                                <strong>
                                  {this.state.selectedBooking.collectionPeriod}
                                </strong>
                              </Typography>
                            </Box>
                          )}
                        </DialogContent>
                      </Paper>
                      <DialogActions>
                        <Button
                          style={{ marginRight: "170px" }}
                          onClick={() => this.downloadWeekInvoice()}
                        >
                          Download Invoice
                        </Button>
                        <Button onClick={this.handleClose}>Close</Button>
                      </DialogActions>
                    </Dialog>
                    <Box sx={{ width: "100%" }}>
                      <Paper
                        elevation={1}
                        onClick={() => this.handleCardClick(eachCard)}
                        sx={{
                          borderRadius: 2,
                          padding: 2,
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          mb: 2,
                          backgroundColor: "rgba(229, 229, 229, 0.3)",
                        }}
                      >
                        {/* LEFT SIDE */}
                        <Box>
                          <Typography
                            variant="body2"
                            color="rgba(107, 114, 120, 1)"
                          >
                            Start Date:
                          </Typography>
                          <Typography
                            variant="body2"
                            color="rgba(107, 114, 120, 1)"
                          >
                            {eachCard.startDate}
                          </Typography>
                          <Typography
                            variant="body2"
                            color="rgba(107, 114, 120, 1)"
                          >
                            End Date:
                          </Typography>
                          <Typography
                            variant="body2"
                            color="rgba(107, 114, 120, 1)"
                          >
                            {eachCard.endDate}
                          </Typography>
                        </Box>

                        {/* RIGHT SIDE */}
                        <Box sx={{ minWidth: 160 }}>
                          <Box
                            display="flex"
                            justifyContent="flex-end"
                            gap={0}
                            sx={{ mt: 0.1 }}
                          >
                            <Typography
                              variant="body2"
                              color="rgba(50, 51, 51, 1)"
                              sx={{ minWidth: 100, fontWeight: 500 }}
                            >
                              Payment From THC:
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: 500 }}
                              color="rgba(50, 51, 51, 1)"
                            >
                              {eachCard.thcOwesHostel}
                            </Typography>
                          </Box>
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="flex-end"
                            gap={1}
                            mt={1}
                          >
                            {/* <BedIcon fontSize="small" /> */}
                            <Typography
                              variant="body2"
                              color="rgba(50, 51, 51, 1)"
                              sx={{ fontWeight: 500 }}
                            >
                              Revenue: {eachCard.totalValueReceived}
                            </Typography>
                          </Box>
                          {eachCard.utrNumber && (
                            <Box gap={1} mt={1}>
                              <Typography
                                variant="body2"
                                color="rgba(50, 51, 51, 1)"
                                textOverflow="ellipsis"
                                width="100%"
                                whiteSpace="nowrap"
                                overflow="hidden"
                                sx={{ fontWeight: 500 }}
                              >
                                UTR: {eachCard.utrNumber}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </Paper>
                    </Box>
                  </React.Fragment>
                );
              })}
          </>
        )}
        {this.state.loading && (
          <div style={{ textAlign: "center", marginTop: "6rem" }}>
            <Spinner />
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(Payments);
